import PropTypes from "prop-types"
import React from "react"

class DatePicker extends React.Component {
  constructor(props) {
    super(props)
    this.datePickerRef = React.createRef()
    this.tryDockOrMooringComponent = this.tryDockOrMooringComponent.bind(this)
    this.setTryDockOrMooringButton = this.setTryDockOrMooringButton.bind(this)
    this.waitlistComponent = this.waitlistComponent.bind(this)
    this.updateDatepicker = this.updateDatepicker.bind(this)
    this.clearDates = this.clearDates.bind(this)
    this.handleAmplitude = this.handleAmplitude.bind(this)
  }

  componentDidMount() {
    $(this.datePickerRef.current)
      .datepicker()
      .on("changeDate", (e) => {
        // set the state of the component to that of the datepicker
        this.props.setParentState(this.datePickerRef.current.value)
      })

    // set the arrows when the popup is shown
    $(this.datePickerRef.current)
      .datepicker()
      .on("show", (e) => {
        const scope = ".datepicker-dropdown"
        $("th.next", scope).html('<i class="fa-kit fa-angle-right"></i>')
        $("th.prev", scope).html('<i class="fa-kit fa-angle-left"></i>')
        this.tryDockOrMooringComponent(scope)
        this.waitlistComponent(scope)
      })

    // Update datepicker after initial mount
    this.updateDatepicker()
  }

  componentDidUpdate(prevProps) {
    // Update datepicker when props change
    if (
      prevProps.startDate !== this.props.startDate ||
      prevProps.endDate !== this.props.endDate ||
      JSON.stringify(prevProps.datesDisabled) !==
        JSON.stringify(this.props.datesDisabled)
    ) {
      this.updateDatepicker()
    }
  }

  tryDockOrMooringComponent(scope) {
    if (this.props.prependDockOrMooring) {
      const id = "datepicker-dock-or-mooring-" + this.props.uniqueKey
      if (!$("." + id, scope).length) {
        $(document).delegate(
          "." + id + " .try-dock-or-mooring",
          "click",
          (e) => {
            this.props.changeDockType(this.props.prependDockOrMooring)
            this.setTryDockOrMooringButton(id, scope)
          }
        )
        $(scope).append('<div class="' + id + '"></div>')
        this.setTryDockOrMooringButton(id, scope)
        $(this.datePickerRef.current).datepicker("show")
      } else {
        this.setTryDockOrMooringButton(id, scope)
      }
    }
  }

  setTryDockOrMooringButton(id, scope) {
    $("." + id, scope).replaceWith(
      '<table class="' +
        id +
        ' table"><tr><td><button class="btn btn-sm btn-secondary w-full try-dock-or-mooring" href="#">Try ' +
        this.props.prependDockOrMooring +
        "s?</button></td></tr></table>"
    )
  }

  waitlistComponent(scope) {
    if (this.props.prependWaitlist) {
      if (!$(".datepicker-waitlist", scope).length) {
        $(document).delegate(
          ".datepicker-waitlist .join-the-waitlist",
          "click",
          (e) => {
            if (this.props.experienceName) {
              this.handleAmplitude(
                `${this.props.experienceName}:join_the_waitlist_pressed`,
                { experience_name: this.props.experienceName }
              )
            }
            this.props.routeTo("Waitlist")
            $(this.datePickerRef.current).datepicker("hide")
          }
        )

        $(scope).append(
          '<table class="datepicker-waitlist table"><tr><td>Don\'t see your preferred dates?<button class="btn btn-sm btn-secondary ml-3 join-the-waitlist" href="#">Join the Waitlist</button></td></tr></table>'
        )
        // this updated the datepicker's location to compensate for the appended HTML
        $(this.datePickerRef.current).datepicker("show")
      }
    }
  }

  updateDatepicker() {
    $(this.datePickerRef.current).datepicker(
      "setStartDate",
      this.props.startDate
    )
    $(this.datePickerRef.current).datepicker("setEndDate", this.props.endDate)
    $(this.datePickerRef.current).datepicker(
      "setDatesDisabled",
      this.props.datesDisabled
    )
  }

  clearDates() {
    $(this.datePickerRef.current).datepicker("update", "")
  }

  handleAmplitude(event, eventProps = {}) {
    Amplitude.trackEvent(event, {
      ...eventProps,
      marina_id: this.props.marina.mcomId,
      marina_name: this.props.marina.name,
    })
  }

  render() {
    return (
      <input
        ref={this.datePickerRef}
        type="text"
        className={`form-control datepicker ${
          this.props.className ? this.props.className : ""
        }`}
        value={this.props.value}
        name={this.props.name}
        id={this.props.id}
        onChange={() => {}}
        placeholder={this.props.placeholder}
        autoComplete="off"
        data-provide="datepicker"
        data-date-start-date={this.props.startDate}
        data-date-end-date={this.props.endDate}
        data-date-dates-disabled={JSON.stringify(
          this.props.datesDisabled || []
        )}
        data-date-clear-btn={!!this.props.clearBtn}
        data-date-autoclose="true"
        data-date-disable-touch-keyboard="true"
        data-date-format={this.props.dateFormat}
        data-date-min-view-mode={this.props.dateMinView}
        data-date-max-view-mode={this.props.dateMaxView}
        // the orientation is the opposite direction as you would expect
        data-date-orientation={this.props.orientation || "auto"}
        disabled={this.props.disabled}
        readOnly={true}
      />
    )
  }
}

DatePicker.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  datesDisabled: PropTypes.array,
  value: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  dateFormat: PropTypes.string,
  dateMinView: PropTypes.number,
  dateMaxView: PropTypes.number,
  orientation: PropTypes.string,
  disabled: PropTypes.bool,
  clearBtn: PropTypes.bool,
  prependDockOrMooring: PropTypes.bool,
  prependWaitlist: PropTypes.bool,
  marina: PropTypes.object,
  uniqueKey: PropTypes.string,
  setParentState: PropTypes.func.isRequired,
  changeDockType: PropTypes.func,
  experienceName: PropTypes.string,
  routeTo: PropTypes.func,
}

export default DatePicker
